module.exports = __webpack_public_path__ + "static/media/abe-hi.42f2688e.png";